export default "__VITE_ASSET__CgwhJ9QI__"